import { render, staticRenderFns } from "./PzSdkForm.vue?vue&type=template&id=39bec9a2"
import script from "./PzSdkForm.vue?vue&type=script&lang=js"
export * from "./PzSdkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39bec9a2')) {
      api.createRecord('39bec9a2', component.options)
    } else {
      api.reload('39bec9a2', component.options)
    }
    module.hot.accept("./PzSdkForm.vue?vue&type=template&id=39bec9a2", function () {
      api.rerender('39bec9a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/DigitalSings/Fad3/PzSdkForm.vue"
export default component.exports